
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/memories",
      function () {
        return require("private-next-pages/memories/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/memories"])
      });
    }
  